import { ReactElement } from 'react';
import { ListItem, ListItemButton, ListItemText, styled } from '@mui/material';

import { Typography } from '../../../Typography';

type ButtonProps = {
  onClick?: () => void;
  label: string;
  secondaryLabel?: string;
  withIconGap?: boolean;
  Icon?: ReactElement;
  disabled?: boolean;
};

const StyledLabels = styled('div')({
  display: 'flex',
  flex: '1',
  justifyCcontent: 'space-between',
  alignItems: 'center',
  gap: '8px',
});

const StyledIconContainer = styled('div')({
  width: '20px',
  height: '14px',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
});

const StyledListItem = styled(ListItem)({
  padding: 0,
  cursor: 'pointer',
  borderRadius: 0,
  '&:first-child': {
    borderRadius: 0,
  },
});

const StyledListItemButton = styled(ListItemButton)({
  padding: 'var(--basic-grid) calc(var(--basic-grid) * 3)',
  cursor: 'pointer',
  '&:first-child': {
    borderRadius: 0,
  },
  '&:hover': {
    backgroundColor: 'var(--color-blue-500)',
  },
});

const StyledListItemText = styled(ListItemText)({
  display: 'flex',
});

const StyledTypography = styled(Typography)({
  fontWeight: ' var(--font-weight-regular)',
  fontSize: 'var(--font-size-regular)',
  lineHeight: 'var(--line-height-medium)',
  userSelect: 'none',
  whiteSpace: 'nowrap',
});

export const Button = ({
  onClick,
  label,
  secondaryLabel,
  withIconGap,
  Icon,
  disabled,
}: ButtonProps) => {
  const onButonClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <StyledListItem data-testid="control-tooltip-button">
      <StyledListItemButton onClick={onButonClick} disabled={disabled}>
        <StyledListItemText disableTypography>
          {withIconGap || !!Icon ? (
            <StyledIconContainer>{Icon}</StyledIconContainer>
          ) : null}
          <StyledLabels>
            <StyledTypography>{label || '-'}</StyledTypography>
            {secondaryLabel ? (
              <StyledTypography data-testid="secondary-label">
                {secondaryLabel}
              </StyledTypography>
            ) : null}
          </StyledLabels>
        </StyledListItemText>
      </StyledListItemButton>
    </StyledListItem>
  );
};
